export default __webpack_public_path__ + "static/4-fbe8342eaf908323f1fe4bc8d5f72fdf.webp";